import { createActionConst } from '../../../utils/action.utils';

const MEETING_ARCHIVE_NAMESPACE = 'MEETING_ARCHIVE';

export const STORE_MEETING_ARCHIVE = createActionConst(MEETING_ARCHIVE_NAMESPACE, 'STORE_MEETING_ARCHIVE');
export const CLEAR_MEETING_ARCHIVE = createActionConst(MEETING_ARCHIVE_NAMESPACE, 'CLEAR_MEETING_ARCHIVE');
